import SearchTextField, { SearchTextFieldStyles } from "@aus/Widgets/WorkOrderHistory/WorkOrderSearchTextField";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

export const poNumberStyles: SearchTextFieldStyles = {};
const styles = poNumberStyles;

const OrderHistorySearchPoNumber: React.FunctionComponent<WidgetProps> = () => {
    return <SearchTextField styles={styles} parameterField="poNumber" label="PO #" inputType="text" placeholder="" />;
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchPoNumber,
    definition: {
        group: "Order History",
        displayName: "Work Order PO Number",
        allowedContexts: ["WorkOrderHistoryPage"] as any,
    },
};

export default widgetModule;
